import React from 'react';
import { createTheme, Switch } from '@mui/material';
import { css } from '@emotion/react'; // Importing css from @emotion/react
import { Color } from '../../constants'; // Assuming Color is defined in your constants

const theme = createTheme();

export const OntegoSwitch = ({ id, style, checked, handleChange, value }) => {
  // Define styles using css({})
  const switchStyles = css({
    width: '42px',
    height: '26px',
    padding: 0,
    // Styles for the switchBase
    '& .MuiSwitch-switchBase': {
      padding: '1px',
      top: 0,
      left: '2px',
      '&.Mui-checked': {
        transform: 'translateX(16px)',
        color: theme.palette.common.white,
        top: 0,
        left: 0,
        '& + .MuiSwitch-track': {
          backgroundColor: Color.primary[500],
          opacity: 1,
          border: 'none',
        },
      },
      '&.Mui-focusVisible .MuiSwitch-thumb': {
        color: Color.primary[500],
      },
    },
    // Styles for the thumb
    '& .MuiSwitch-thumb': {
      marginTop: '1px',
      width: '22px',
      height: '22px',
    },
    // Styles for the track
    '& .MuiSwitch-track': {
      borderRadius: '13px', // 26px / 2
      backgroundColor: Color.neutral[500],
      opacity: 1,
      transition: theme.transitions.create(['background-color', 'border']),
    },
  });

  return (
    <Switch
      checked={checked}
      onChange={handleChange}
      value={value}
      style={style}
      id={id}
      css={switchStyles} // Applying the styles using css prop
      disableRipple
    />
  );
};

export default OntegoSwitch;
